import { useQuery } from '@tanstack/react-query';
import { GetSchedulingsForQuestionnaireDTO } from '@aphp-ema/common/scheduling/GetSchedulingsForQuestionnaireDTO';
import { getQuestionnaireScheduling } from './scheduling.api';

export const useGetQuestionnaireScheduling = (questionnaireId: string) => {
  return useQuery({
    queryKey: ['questionnaire-scheduling', questionnaireId],
    queryFn: (): Promise<GetSchedulingsForQuestionnaireDTO> =>
      getQuestionnaireScheduling(questionnaireId),
    enabled: !!questionnaireId,
  });
};
